import { requireOptionalNativeModule } from 'expo-modules-core';

/**
 * UN MODULE NATIF ABSENT NE DOIT JAMAIS FAIRE PLANTER L'APP AU DÉMARRAGE.
 *
 * `import 'expo-audio'` (ou `expo-print`) appelle `requireNativeModule` dès le chargement, et lève si
 * le binaire ne contient pas le module : c'est le plantage vécu avec ExpoAsset le 10/10/2026. Un
 * binaire plus ancien que le JavaScript qu'il charge (build de développement, mise à jour à distance)
 * s'y expose. Les modules facultatifs se chargent donc à la demande, après ce contrôle.
 */
export function moduleNatifPresent(nom: string): boolean {
  try {
    return requireOptionalNativeModule(nom) !== null;
  } catch {
    return false;
  }
}
